import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('userDetailsPage');

    return {
        APPLICATIONS: t('applications'),
        EDIT_USER: t('editUser'),
        LINKED_ENTITIES: t('linkedEntities')
    };
};

export default useTranslation;
